module.exports = __webpack_public_path__ + "img/people_img_1_2.b5aa5fed.png";